import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ModalAlertComponent } from '@app/shared/components/modal-alert/modal-alert.component';

@Injectable()
export class ModalAlertService {

  constructor(private dialog: MatDialog) { }

  openModal(modalOptions: any): MatDialogRef<any> {

    const dialog = this.dialog.open(modalOptions.component, {
      width: modalOptions.width || '600px',
      disableClose: true,
      data: modalOptions.data
    });

    if (modalOptions.afterClosedFN) {
      dialog.afterClosed().subscribe(() => {
        modalOptions.afterClosedFN();
      });
    }

    return dialog;
  }

  showAlert(modalOptions: any): MatDialogRef<any> {
    const dialog = this.dialog.open(ModalAlertComponent, {
      width: modalOptions.width || '600px',
      disableClose: true,
      data: modalOptions.data
    });

    dialog.componentInstance.acceptFN.subscribe(_ => {
      dialog.close();
    });

    return dialog;
  }
}
